import { useExperiment } from '../hooks/use-experiment';

import { EXPERIMENT_KEY } from './constants';

/**
 * Resolves the active variant of the project/outcome-first PLP experiment from
 * the route-swapped pathname, e.g. `variant_b` on
 * `/test/ab_project_outcomes_first_plp/variant_b/course/[slug]`. Returns
 * `undefined` on the canonical `/course/[slug]` route.
 */
export function useProjectOutcomesFirstPLPVariant(): string | undefined {
  return useExperiment()?.[EXPERIMENT_KEY];
}

export const CHALLENGER_VARIANT = 'variant_b';

/**
 * The challenger moves the syllabus CTA into the "What you'll build" header, so
 * the standalone mid-page button is suppressed to avoid rendering it twice.
 */
export function useIsProjectsFirstChallenger(): boolean {
  return useProjectOutcomesFirstPLPVariant() === CHALLENGER_VARIANT;
}
